import React from 'react';
import './App.css';
import useScrollReveal from './hooks/useScrollReveal';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import About from './components/About';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  useScrollReveal();

  return (
    <>
      <div className="grain-overlay"></div>
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <div className="section-divider"></div>
      <Portfolio />
      <div className="section-divider"></div>
      <About />
      <div className="section-divider"></div>
      <Process />
      <div className="section-divider"></div>
      <Testimonials />
      <div className="section-divider"></div>
      <Contact />
      <Footer />
      <ScrollToTop />
    </>
  );
}

export default App;
